/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_TaxService_Dtos_CriteriaType_CriteriaTypeDto } from '../models/Wealthlane_TaxService_Dtos_CriteriaType_CriteriaTypeDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CriteriaTypeService {

    /**
     * @param criteriaId 
     * @returns Wealthlane_TaxService_Dtos_CriteriaType_CriteriaTypeDto OK
     * @throws ApiError
     */
    public static getApiTaxApiAppCriteriaTypeCriteriaType(
criteriaId: string,
): CancelablePromise<Wealthlane_TaxService_Dtos_CriteriaType_CriteriaTypeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tax/api/app/criteria-type/criteria-type/{CriteriaId}',
            path: {
                'CriteriaId': criteriaId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_TaxService_Dtos_CriteriaType_CriteriaTypeDto OK
     * @throws ApiError
     */
    public static getApiTaxApiAppCriteriaTypeCriteriaTypesListAync(): CancelablePromise<Array<Wealthlane_TaxService_Dtos_CriteriaType_CriteriaTypeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tax/api/app/criteria-type/criteria-types-list-aync',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
